const CURRENCY_LOCALE: Record<string, string> = {
  NOK: 'nb-NO',
  SEK: 'sv-SE',
  DKK: 'da-DK',
  USD: 'en-US',
  GBP: 'en-GB',
  EUR: 'de-DE'
};

const DEFAULT_LOCALE = 'en-GB';

export function localeForCurrency(currencyCode: string): string {
  const code = currencyCode.trim().toUpperCase();
  if (code.length !== 3) {
    return DEFAULT_LOCALE;
  }
  return CURRENCY_LOCALE[code] ?? DEFAULT_LOCALE;
}

export function formatMoneyNumber(amount: number, currencyCode: string): string {
  const code = currencyCode.trim().toUpperCase() || '???';
  const locale = localeForCurrency(code);
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(amount);
}

export function formatMoneyAmount(amount: number, currencyCode: string): string {
  const code = currencyCode.trim().toUpperCase() || '???';
  return `${formatMoneyNumber(amount, code)} ${code}`;
}
